<template>
  <div class="reports">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <div class="card mb-5">
            <h4 class="card-header">
              <i class="fa fa-fw fa-calendar"></i> Select Date
            </h4>
            <div class="card-body">
              <calendar-input
                :options="{
                  name: 'date',
                  label: 'Select a Date',
                  noLabel: true,
                  inline: true,
                  highlightDates: true
                }" :selectedDates="loadedReports.dates"
                @input="goToDate($event)"
                ref="datePicker">
              </calendar-input>
            </div>
          </div>
        </div>
        <div class="col-md-8" v-if="$route.meta.showSearch">
          <div
            @click="toggleSearch()"
            v-show="searchHidden">
            <p class="form-control text-muted fake-input interactive-cursor">
              Search...
              <span class="fa fa-search float-right"></span>
            </p>
          </div>
          <div v-show="!searchHidden">
            <vue-form
                ref="form"
                :sections="reportsSearchForm"
                :options="{
                  submit: 'Search',
                  submitting: 'Searching...',
                  permalink: $route.meta.reportType,
                  method: 'search',
                  fullWidth: true
                }">
              <span slot="title">
                <i class="fa fa-search fa-fw"></i> Search {{ loadedReports.searchForm.plural }}
                <span
                  class="fa fa-times float-right fa-lg interactive-cursor"
                  @click="toggleSearch()">
                </span>
              </span>
              <div class="col" slot="actions">
                <p>
                  <strong>
                    Selected Date:
                  </strong>
                  <span v-if="date">
                    {{ date | date_format }}
                  </span>
                  <span v-else>
                    {{ 'Date not selected' }}
                  </span>
                  <button class="btn btn-info btn-sm" type="button" @click="removeDate()">
                    <i class="fa fa-times"></i>
                  </button>
                </p>
                <button class="btn btn-info" type="button" @click="directSearch()">
                  <i class="fa fa-search fa-fw"></i> Search
                </button>
              </div>
            </vue-form>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-12">
              <paging-input ref="paging"
              @change="changePage"
              :options="{
                current: (loadedReports.offset + loadedReports.limit) / loadedReports.limit,
                totalResults: loadedReports.count,
                limit: loadedReports.limit
              }"
              v-if="loadedReports.count">
              </paging-input>
              <div v-if="loadedReports.permalink === $route.meta.reportType && loadedReports.rows.length">
                <div v-for="(object, i) in loadedReports.rows" :class="{ 'hover': i % 2 == 0 }" :key="i">
                  <component :is="$route.meta.reportType + '-card'" :object="object">
                  </component>
                </div>
              </div>
              <paging-input ref="paging"
                @change="changePage"
                :options="{
                  current: (loadedReports.offset + loadedReports.limit) / loadedReports.limit,
                  totalResults: loadedReports.count,
                  limit: loadedReports.limit
                }"
                v-if="loadedReports.count">
              </paging-input>
              <div class="alert alert-info" v-else>
                <i class="far fa-meh fa-fw fa-lg"></i> No items were found that matched your criteria
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div @click="createQuote()" v-if="$route.meta.reportType === 'quote'" id="createQuote" :title="'Create New Quote'">
      <span class="fa fa-plus-square fa-lg"></span>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex'
  import { LOAD_REPORTS } from '@/vuex/types'
  import CalendarInput from '@/components/inputs/CalendarInput'
  import PagingInput from '@/components/inputs/PagingInput'
  // import NavTab from '@/components/ui/NavTab'
  // import Tab from '@/components/ui/Tab'
  import WaitingCustomerCard from '@/components/cards/Customer'
  import QuoteCard from '@/components/cards/Quote'
  import InvoiceCard from '@/components/cards/Invoice'
  import VueForm from '@/components/Form'
  export default {
    name: 'Reports',
    components: {
      // NavTab,
      // Tab,
      CalendarInput,
      PagingInput,
      QuoteCard,
      InvoiceCard,
      WaitingCustomerCard,
      VueForm
    },
    async mounted () {
      this.createNewSearch()
    },
    data () {
      return {
        editFormPermalink: '',
        editFormUuid: '',
        searchForm: [],
        searchOffset: 0,
        searchLimit: 10,
        searchHidden: false,
        newSearch: true,
        date: false,
        noResults: 'Your search returned 0 results',
        pagingOptions: {
          totalResults: 10,
          limit: 10,
          current: 1
        },
        searchIndex: 0
      }
    },
    computed: {
      ...mapGetters([
        'loadedReports',
        'reportsSearchForm',
        '$sidebar'
      ])
    },
    watch: {
      $route () {
        this.createNewSearch()
      }
    },
    methods: {
      async createNewSearch () {
        this.searchOffset = 0
        let reportData = {
          reportType: this.$route.meta.reportType,
          reportUuid: this.$route.query.report,
          searchForm: [],
          date: null,
          offset: this.searchOffset,
          limit: this.loadedReports.limit,
          newSearch: true
        }
        await this.$store.dispatch(LOAD_REPORTS, reportData)
        // Default today's date removed to show all the quotes
        // this.$refs.datePicker.setDate(new Date())
      },
      async search () {
        await this.$refs.form.validateForm()
        if (this.$refs.form.validForm) {
          let searchForm = this.reportsSearchForm
          searchForm.splice(-1, 1)
          let reportData = {
            reportType: this.$route.meta.reportType,
            searchForm,
            offset: this.searchOffset,
            limit: this.loadedReports.limit,
            date: this.date,
            newSearch: this.newSearch
          }
          await this.$store.dispatch(LOAD_REPORTS, reportData)
        }
      },
      async goToDate (date) {
        if (this.searchIndex || !this.$route.query.report) {
          this.searchOffset = 0
          this.date = date
          let reportData = {
            reportType: this.$route.meta.reportType,
            searchForm: [],
            date,
            offset: this.searchOffset,
            limit: this.loadedReports.limit,
            newSearch: true
          }
          await this.$store.dispatch(LOAD_REPORTS, reportData)
        }
        this.searchIndex = 1
      },
      async toggleSearch () {
        this.searchHidden = !this.searchHidden
        if (!this.searchHidden) {
          await this.$nextTick()
          this.$refs.form.$el.querySelectorAll('input[type=text]')[0].focus()
        }
      },
      async removeDate () {
        this.date = false
        this.$refs.datePicker.setDate()
        await this.search()
      },
      async changePage (page) {
        this.searchOffset = (page - 1) * this.loadedReports.limit
        await this.search()
      },
      async directSearch () {
        this.searchOffset = 0
        await this.search()
      },
      // TODO Need to check whether this needs to be done.
      createQuote () {
        this.$router.push('/newQuote')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/Reports.vue